import * as React from "react";

// Default context values
const values = {
  containerDimension: undefined,
  setCurrentSlide: Function,
};

const GalleryContainerContext = React.createContext(values);
export default GalleryContainerContext;
